import React, { useEffect, useRef } from "react";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";

const VideoSection: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const desktopVideo = "https://dprstorage.b-cdn.net/kolla/1.mp4";
  const mobileVideo = "https://dprstorage.b-cdn.net/kolla/Videos/kolllagropmobileview.mp4";

  useEffect(() => {
    const videoEl = videoRef.current;
    if (videoEl) {
      videoEl.muted = true; // Ensure video is muted by default
      videoEl.playsInline = true; // Enable inline playback for iOS
      videoEl.setAttribute("preload", "auto"); // Preload video for faster loading
      videoEl.setAttribute("playsinline", "true"); // iOS compatibility

      // Attempt to play the video immediately
      const playPromise = videoEl.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Autoplay blocked, user interaction required.", error);
        });
      }
    }
  }, []);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        padding: 0,
        margin: 0,
        height: "100vh",
        backgroundColor: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
        "&::-webkit-scrollbar": { display: "none" },
        "-ms-overflow-style": "none",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          backgroundColor: "#000",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            paddingTop: isMobile ? "177.77%" : "56.25%", // 9:16 for phone, 16:9 for desktop
            overflow: "hidden",
          }}
        >
          <video
            ref={videoRef}
            muted
            loop
            autoPlay
            playsInline
            preload="auto"
            controls={false}
            onContextMenu={(e) => e.preventDefault()}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          >
            <source src={isMobile ? mobileVideo : desktopVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Box>
      </Box>
    </Container>
  );
};

export default VideoSection;
